<template>
  <v-container>
    <div
      v-for="(item2, idx) in fileList"
      :key="idx"
      class="d-flex justify-start align-center"
    >
      <FileItem :item="item2" />
    </div>
  </v-container>
</template>
<script>
import FileItem from "@/components/ui/detailComponent/FileItem.vue";
export default {
  components: {
    FileItem
  },
  props: {
    item: {
      type: Object,
      default() {
        return {
          Sno: -1
        };
      }
    }
  },
  data() {
    return {
      fileList: []
    };
  },
  watch: {
    async "item.Sno"() {
      this.fileList = await this.SYS.getFileList(this.item, 1);
    }
  },
  mounted() {
    this.SYS.getFileList(this.item, 1).then(data => {
      this.fileList = data;
    });
  }
};
</script>
<style lang="scss" scoped></style>
